import { Theme } from '@mui/material/styles'
import { createUseStyles } from 'react-jss'

const width = 18
const height = 18

export default createUseStyles(
  (theme: Theme) => ({
    checkboxRoot: {
      position: 'relative',
      '& > *': {
        cursor: 'pointer',
      },
      '& > label': {
        display: 'flex',
      },
      '& input:checked + $checkmark': {
        border: 'none',
        backgroundColor: theme.palette.primary.main,
      },
      '& input:checked + $checkmark:after': {
        display: 'block',
      },
      '& $checkmark:after': {
        left: 5.5,
        top: 0.5,
        width: 5,
        height: 10,
        border: 'solid white',
        borderWidth: '0 2px 2px 0',
        transform: 'rotate(45deg)',
        boxSizing: 'content-box',
      },
      '& input[type="checkbox"]': {
        cursor: 'pointer',
        position: 'absolute',
        clip: 'rect(0 0 0 0)',
      },
    },
    checkmark: {
      position: 'relative',
      flexShrink: 0,
      boxSizing: 'border-box',
      borderRadius: 3,
      width: width,
      height: height,
      border: [3, 'solid', 'rgba(0, 0, 0, 0.6)'],
      '&:after': {
        content: '" "',
        position: 'absolute',
        display: 'none',
      },
    },
    label: {
      marginLeft: 8,
    },
  }),
  { name: 'Checkbox' }
)
